var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webphone-dialer" }, [
    _c("div", { staticClass: "call-status-display" }, [
      _vm.callState.status === "idle"
        ? _c("div", { staticClass: "idle-display" }, [
            _c("div", { staticClass: "dial-number" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localDialNumber,
                    expression: "localDialNumber",
                  },
                ],
                ref: "numberInput",
                staticClass: "number-input",
                class: { "number-input--invalid": _vm.phoneNumberWarning },
                attrs: {
                  "aria-invalid": !!_vm.phoneNumberWarning,
                  placeholder: "Numara girin...",
                  type: "tel",
                },
                domProps: { value: _vm.localDialNumber },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.localDialNumber = $event.target.value
                    },
                    _vm.handleNumberInput,
                  ],
                  keydown: _vm.handleKeyDown,
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sip-info" }, [
              _c("span", { staticClass: "extension-info" }, [
                _vm._v(
                  _vm._s(_vm.sipStatus.extensionNumber) +
                    "@" +
                    _vm._s(_vm.sipStatus.domain)
                ),
              ]),
            ]),
          ])
        : _vm.callState.status === "calling"
        ? _c("div", { staticClass: "calling-display" }, [
            _c("div", { staticClass: "status-text" }, [_vm._v("Aranıyor...")]),
            _vm._v(" "),
            _c("div", { staticClass: "caller-number" }, [
              _vm._v(_vm._s(_vm.callState.callerNumber)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "call-timer" }, [
              _vm._v(_vm._s(_vm.formatDuration(_vm.callElapsed))),
            ]),
          ])
        : _vm.callState.status === "ringing"
        ? _c("div", { staticClass: "ringing-display" }, [
            _c("div", { staticClass: "status-text" }, [_vm._v("Çalıyor...")]),
            _vm._v(" "),
            _c("div", { staticClass: "caller-number" }, [
              _vm._v(_vm._s(_vm.callState.callerNumber)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "call-timer" }, [
              _vm._v(_vm._s(_vm.formatDuration(_vm.callElapsed))),
            ]),
          ])
        : _vm.callState.status === "incoming"
        ? _c("div", { staticClass: "incoming-display" }, [
            _c("div", { staticClass: "status-text" }, [_vm._v("Gelen Arama")]),
            _vm._v(" "),
            _c("div", { staticClass: "caller-info" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "caller-details" }, [
                _c("div", { staticClass: "caller-name" }, [
                  _vm._v(_vm._s(_vm.callState.callerName || "Bilinmeyen")),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "caller-number" }, [
                  _vm._v(_vm._s(_vm.callState.callerNumber)),
                ]),
              ]),
            ]),
          ])
        : _vm.callState.status === "connected"
        ? _c("div", { staticClass: "connected-display" }, [
            _c("div", { staticClass: "status-text" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.callState.isOnHold ? "Beklemede" : "Konuşuyor") +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "caller-number" }, [
              _vm._v(_vm._s(_vm.callState.callerNumber)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "call-timer" }, [
              _vm._v(_vm._s(_vm.formatDuration(_vm.callState.callDuration))),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.shouldShowKeypad
      ? _c(
          "div",
          { staticClass: "keypad" },
          _vm._l(_vm.keypadLayout, function (row, rowIndex) {
            return _c(
              "div",
              { key: rowIndex, staticClass: "keypad-row" },
              _vm._l(row, function (key) {
                return _c(
                  "button",
                  {
                    key: key.value,
                    staticClass: "keypad-key",
                    class: { "key-action": key.action },
                    on: {
                      click: function ($event) {
                        return _vm.handleKeyPress(key.value)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "key-primary" }, [
                      _vm._v(_vm._s(key.primary)),
                    ]),
                    _vm._v(" "),
                    key.secondary
                      ? _c("span", { staticClass: "key-secondary" }, [
                          _vm._v(_vm._s(key.secondary)),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "call-actions" }, [
      _vm.callState.status === "idle"
        ? _c("div", { staticClass: "idle-actions" }, [
            _c(
              "button",
              {
                staticClass: "action-btn clear-btn",
                attrs: {
                  disabled: !_vm.localDialNumber,
                  title: "Numarayı temizle",
                },
                on: { click: _vm.clearNumber },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("clear")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn call-btn",
                attrs: {
                  disabled:
                    !_vm.localDialNumber.trim() || !_vm.sipStatus.isRegistered,
                  title: "Aramayı başlat",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("call")
                  },
                },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("call")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn delete-btn",
                attrs: {
                  disabled: !_vm.localDialNumber,
                  title: "Son rakamı sil",
                },
                on: { click: _vm.deleteDigit },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("backspace"),
                ]),
              ]
            ),
          ])
        : _vm.callState.status === "incoming"
        ? _c("div", { staticClass: "incoming-actions" }, [
            _c(
              "button",
              {
                staticClass: "action-btn answer-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("answer")
                  },
                },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("call")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn reject-btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("reject")
                  },
                },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("call_end")])]
            ),
          ])
        : _vm.callState.status === "calling" ||
          _vm.callState.status === "ringing"
        ? _c("div", { staticClass: "calling-actions" }, [
            _c(
              "button",
              {
                staticClass: "action-btn hangup-btn",
                on: { click: _vm.hangup },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("call_end")])]
            ),
          ])
        : _vm.callState.status === "connected"
        ? _c("div", { staticClass: "connected-actions" }, [
            _c(
              "button",
              {
                staticClass: "action-btn mute-btn",
                class: { active: _vm.callState.isMuted },
                on: {
                  click: function ($event) {
                    return _vm.$emit("mute")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(_vm.callState.isMuted ? "mic_off" : "mic")),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn hold-btn",
                class: { active: _vm.callState.isOnHold },
                on: {
                  click: function ($event) {
                    return _vm.$emit("hold")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v(
                    _vm._s(_vm.callState.isOnHold ? "play_arrow" : "pause")
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn keypad-toggle-btn",
                on: { click: _vm.toggleKeypad },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("dialpad")])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn transfer-btn",
                attrs: { title: "Yönlendir" },
                on: { click: _vm.showTransfer },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("call_split"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "action-btn hangup-btn",
                on: { click: _vm.hangup },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("call_end")])]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.showTransferModal
      ? _c(
          "div",
          {
            staticClass: "transfer-modal",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.cancelTransfer.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "transfer-content" }, [
              _c("div", { staticClass: "transfer-header" }, [
                _c("h4", [_vm._v("Aramayı Yönlendir")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-btn",
                    on: { click: _vm.cancelTransfer },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("close"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "transfer-mode-tabs" }, [
                _c(
                  "button",
                  {
                    staticClass: "mode-tab",
                    class: { active: _vm.transferMode === "extension" },
                    on: {
                      click: function ($event) {
                        _vm.transferMode = "extension"
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("people"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Dahiliye Yönlendir")]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "mode-tab",
                    class: { active: _vm.transferMode === "manual" },
                    on: {
                      click: function ($event) {
                        _vm.transferMode = "manual"
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("dialpad"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Numaraya Yönlendir")]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.transferMode === "extension"
                ? _c("div", { staticClass: "extension-mode" }, [
                    _c("div", { staticClass: "search-box" }, [
                      _c("i", { staticClass: "material-icons search-icon" }, [
                        _vm._v("search"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery",
                          },
                        ],
                        staticClass: "search-input",
                        attrs: { placeholder: "Dahili ara..." },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuery = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "extensions-list" },
                      [
                        _vm.filteredExtensions.length === 0
                          ? _c("div", { staticClass: "no-results" }, [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("search_off"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("Dahili bulunamadı")]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.filteredExtensions, function (extension) {
                          return _c(
                            "div",
                            {
                              key: extension.extension,
                              staticClass: "extension-item",
                              class: {
                                selected:
                                  _vm.selectedExtension === extension.extension,
                                offline: !extension.registeraddr,
                                busy: extension.isBusy,
                                disabled: !extension.isAvailable,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectExtension(extension)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "extension-avatar-wrapper" },
                                [
                                  _vm.mapping[extension.extension]
                                    ? _c("AgentAvatar", {
                                        attrs: {
                                          userID:
                                            _vm.mapping[extension.extension],
                                          size: 32,
                                          isNamed: false,
                                        },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "default-avatar",
                                          style: {
                                            backgroundColor: _vm.getAvatarColor(
                                              extension.displayname
                                            ),
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getInitials(
                                                  extension.displayname
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "status-indicator",
                                    class: {
                                      online:
                                        extension.registeraddr &&
                                        !extension.isBusy,
                                      busy:
                                        extension.registeraddr &&
                                        extension.isBusy,
                                      offline: !extension.registeraddr,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "extension-info" }, [
                                _c("div", { staticClass: "extension-name" }, [
                                  _vm._v(_vm._s(extension.displayname)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "extension-number" }, [
                                  _vm._v(_vm._s(extension.extension)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "extension-status" }, [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons status-icon",
                                      class: {
                                        online:
                                          extension.registeraddr &&
                                          !extension.isBusy,
                                        busy:
                                          extension.registeraddr &&
                                          extension.isBusy,
                                        offline: !extension.registeraddr,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            !extension.registeraddr
                                              ? "phone_disabled"
                                              : extension.isBusy
                                              ? "phone_in_talk"
                                              : "phone"
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        !extension.registeraddr
                                          ? "Çevrimdışı"
                                          : extension.isBusy
                                          ? "Meşgul"
                                          : "Müsait"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.selectedExtension === extension.extension
                                ? _c(
                                    "div",
                                    { staticClass: "selection-indicator" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("check_circle")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !extension.isAvailable
                                ? _c(
                                    "div",
                                    { staticClass: "disabled-overlay" },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("block")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.transferMode === "manual"
                ? _c("div", { staticClass: "manual-mode" }, [
                    _c("div", { staticClass: "manual-input-container" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.manualTransferNumber,
                            expression: "manualTransferNumber",
                          },
                        ],
                        staticClass: "manual-number-input",
                        attrs: { type: "tel", placeholder: "05321234567" },
                        domProps: { value: _vm.manualTransferNumber },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.manualTransferNumber = $event.target.value
                            },
                            _vm.handleManualNumberInput,
                          ],
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.confirmTransfer.apply(null, arguments)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(2),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "transfer-actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "cancel-btn",
                    on: { click: _vm.cancelTransfer },
                  },
                  [_vm._v("İptal")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "confirm-btn",
                    attrs: { disabled: !_vm.isTransferValid },
                    on: { click: _vm.confirmTransfer },
                  },
                  [_vm._v("\n                    Yönlendir\n                ")]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caller-avatar" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "manual-input-label" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("phone")]),
      _vm._v(" "),
      _c("span", [_vm._v("Yönlendirmek istediğiniz numarayı girin")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "manual-input-hint" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Telefon numarası girerken boşluk ve özel karakterler otomatik temizlenir"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }